import { render, staticRenderFns } from "./ISwitcher.vue?vue&type=template&id=52385848&"
import script from "./ISwitcher.vue?vue&type=script&lang=ts&"
export * from "./ISwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports